import React, {useEffect, useState} from 'react';
import PageHeader1 from '../../components/common/PageHeader1';
import apiClient from "../../utils/api";
import EditButton from "../../components/common/EditButton";
import DeleteButton from "../../components/common/DeleteButton";

function WebUsersList() {
    const [users, setUsers] = useState([]);
    const fetchUsers = async (page = 1) => {
        try {
            const response = await apiClient.get('admin/webusers');
            setUsers(response.data.data);
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const deleteApi = async (id) => {
        if (!window.confirm('Are you sure you want to delete this API key?')) {
            return;
        }

        try {
            await apiClient.delete(`admin/webusers/${id}`);
            fetchUsers();

        } catch (error) {
            console.error('Error deleting API key:', error);
        }
    };


    return (
        <div className="body d-flex py-3">
            <div className="container-xxl">
                <PageHeader1 pagetitle='Users List' righttitle='Add User' link='/web-users-add'
                             routebutton={true} permission=""/>
                <div className="row g-3 mb-3">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <div id="myDataTable_wrapper" className="dataTables_wrapper dt-bootstrap5 no-footer">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className='table-responsive'>
                                                <table id="myDataTable"
                                                       className="table table-hover align-middle mb-0 nowrap dataTable no-footer dtr-inline"
                                                       style={{width: '100%'}} role="grid"
                                                       aria-describedby="myDataTable_info">
                                                    <thead>
                                                    <tr role="row">
                                                        <th className="sorting_asc" tabIndex="0"
                                                            aria-controls="myDataTable" rowSpan="1" colSpan="1"
                                                            style={{width: '32.2px'}}
                                                            aria-label="Id: activate to sort column descending"
                                                            aria-sort="ascending">Id
                                                        </th>
                                                        <th className="sorting" tabIndex="0"
                                                            aria-controls="myDataTable" rowSpan="1" colSpan="1"
                                                            style={{width: '117.2px'}}
                                                            aria-label="Categorie: activate to sort column ascending">Name
                                                        </th>
                                                        <th className="sorting" tabIndex="0"
                                                            aria-controls="myDataTable" rowSpan="1" colSpan="1"
                                                            style={{width: '117.2px'}}
                                                            aria-label="Categorie: activate to sort column ascending">Email
                                                        </th>
                                                        <th className="sorting" tabIndex="0"
                                                            aria-controls="myDataTable" rowSpan="1" colSpan="1"
                                                            style={{width: '117.2px'}}
                                                            aria-label="Categorie: activate to sort column ascending">Nationality
                                                        </th>

                                                        <th className="sorting" tabIndex="0"
                                                            aria-controls="myDataTable" rowSpan="1" colSpan="1"
                                                            style={{width: '117.2px'}}
                                                            aria-label="Categorie: activate to sort column ascending">Dob
                                                        </th>

                                                        <th className="sorting" tabIndex="0"
                                                            aria-controls="myDataTable" rowSpan="1" colSpan="1"
                                                            style={{width: '117.2px'}}
                                                            aria-label="Categorie: activate to sort column ascending">Referral Source
                                                        </th>

                                                        <th className="dt-body-right sorting" tabIndex="0"
                                                            aria-controls="myDataTable" rowSpan="1" colSpan="1"
                                                            style={{width: '118.2px'}}
                                                            aria-label="Date: activate to sort column ascending">Created
                                                            Date
                                                        </th>
                                                        <th className="sorting" tabIndex="0"
                                                            aria-controls="myDataTable" rowSpan="1" colSpan="1"
                                                            style={{width: '59.2px'}}
                                                            aria-label="Status: activate to sort column ascending">Status
                                                        </th>
                                                        <th className="dt-body-right sorting" tabIndex="0"
                                                            aria-controls="myDataTable" rowSpan="1" colSpan="1"
                                                            style={{width: '75.2px'}}
                                                            aria-label="Action: activate to sort column ascending">Action
                                                        </th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {users.map((user, index) => (
                                                        <tr id={index} role="row"
                                                            className={index % 2 === 0 ? 'odd' : 'even'}>
                                                            <td className="sorting_1" tabIndex="0">#{index + 1}</td>
                                                            <td className="sorting_1" tabIndex="0">{user.name}</td>
                                                            <td className="sorting_1" tabIndex="0">{user.email}</td>
                                                            <td className="sorting_1"
                                                                tabIndex="0">{user.nationality}</td>
                                                            <td className="sorting_1" tabIndex="0">{user.dob}</td>
                                                            <td className="sorting_1" tabIndex="0">{user.referral_source}</td>

                                                            <td className=" dt-body-right">{user.created_at}{/*March 13, 2021*/}</td>
                                                            <td>
                                                                    <span
                                                                        className={`badge ${user.is_active ? 'bg-success' : 'bg-warning'}`}>
                                                                        {user.is_active ? 'Active' : 'InActive'}
                                                                    </span>
                                                            </td>
                                                            <td className=" dt-body-right">
                                                                <div className="btn-group" role="group"
                                                                     aria-label="Basic outlined example">

                                                                    <EditButton
                                                                        to={`${process.env.PUBLIC_URL}/web-users-edit/${user.id}`}
                                                                        //permission="web-users.edit"
                                                                    />

                                                                    <DeleteButton
                                                                        //permission="webusers.delete"
                                                                        onDelete={() => deleteApi(user.id)}
                                                                    />

                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WebUsersList;